<template>
  <Modal
    :id="'cmp-royalty-contracts-sidewindow-royalty_rate_form'"
    @cancelled="onCancel"
  >
    <template slot="header"
      >{{ title }} {{ channel }}</template
    >

    <template slot="body">
      <div class="">
        <div class="dt-modal--row">
          <div class="dt-modal--column form-group">
            <TextField
              :id="'option_name'"
              class="m1"
              v-bind="textFieldConfig"
              :value="royaltyRate.ro.option_name"
              :placeholder="$t('royalty_option_name')"
              @valuechanged="onTextFieldValueChange"
            />
          </div>
          <div class="dt-modal--column"></div>
        </div>
      </div>
      <!-- <div class="body-container"> -->
      <div class="dt-modal--row">
        <div class="dt-modal--column form-group m1 m2 m4">
          <div class="dt-modal--subtitle ut-mt-0">
            Royalty Rate and Deductions
          </div>
          <!-- <div class="dt-modal--column-body"> -->
          <TextField
            :id="'royalty_rate'"
            class="m1"
            :inputType="'number'"
            v-bind="textFieldConfig"
            :value="royaltyRate.ro.royalty_rate"
            :placeholder="$t('royalty_rate')"
            @valuechanged="onTextFieldValueChange"
          />

          <Dropdown
            v-if="channel == 'physical'"
            :id="'base'"
            class="m2"
            :options="physicalBaseTV"
            :selected="physicalBaseTV.find(b => b.value == royaltyRate.ro.base)"
            :placeholder="$t('royalty_base')"
            deselect
            box
            @selectedChange="b => onDropdownChange('base', b)"
          ></Dropdown>

          <Dropdown
            v-if="channel == 'digital'"
            :id="'base'"
            class="m2"
            :options="digitalBaseTV"
            :selected="digitalBaseTV.find(b => b.value == royaltyRate.ro.base)"
            :placeholder="$t('base')"
            deselect
            box
            @selectedChange="b => onDropdownChange('base', b)"
          ></Dropdown>

          <div class="ut-flex">
            <div class="search--input">
              <TextField
                :id="'ppu_adjustment'"
                class="m1"
                v-bind="textFieldConfig"
                :value="royaltyRate.ro.ppu_adjustment"
                :placeholder="$t('adjustment')"
                @valuechanged="onTextFieldValueChange"
              />
            </div>
            <div  class="search--checkbox omit">
              <div
                class="omit-toggler"
                :class="{
                  missed: isOmitted('ppu_adjustment')
                }"
                @click="e => onSearchOmittedToggle('ppu_adjustment')"
              >
                <!-- <div v-if="royaltyRate.ro.ppu_adjustment" class="dt-icon-container">
                  <img
                    :src="
                     royaltyRate.ro.ppu_adjustment>0
                        ? 'static/icons/plus.svg'
                        : 'static/icons/minus.svg'
                    "
                    class="dt-icon s1 v7"
                    alt="Omit"
                    title="Omit"
                  />
                </div> -->
                <div  v-if="royaltyRate.ro.ppu_adjustment">
                  <label v-if="royaltyRate.ro.ppu_adjustment>=0" style="color:rgb(86 86 185)" class="omit-toggler--label">ROY+</label>
                  <label v-if="royaltyRate.ro.ppu_adjustment<0" style="color:rgb(234, 35, 35)" class="omit-toggler--label">ROY-</label>
                </div>
              </div>
            </div>
          </div>
          <div class="ut-flex">
            <div class="search--input">
              <TextField
                :id="'ppu_adjustment_amount'"
                class="m1"
                v-bind="textFieldConfig"
                :value="royaltyRate.ro.ppu_adjustment_amount"
                :placeholder="$t('adjustment_amount')"
                @valuechanged="onTextFieldValueChange"
              />
            </div>
            <div  class="search--checkbox omit">
              <div
                class="omit-toggler"
                :class="{
                  missed: isOmitted('ppu_adjustment_amount')
                }"
                @click="e => onSearchOmittedToggle('ppu_adjustment_amount')"
              >
                <!-- <div v-if="royaltyRate.ro.ppu_adjustment_amount" class="dt-icon-container">
                  <img
                    :src="
                     royaltyRate.ro.ppu_adjustment_amount>0
                        ? 'static/icons/plus.svg'
                        : 'static/icons/minus.svg'
                    "
                    class="dt-icon s1 v7"
                    alt="Omit"
                    title="Omit"
                  />
                </div> -->
                <div  v-if="royaltyRate.ro.ppu_adjustment_amount">
                  <label v-if="royaltyRate.ro.ppu_adjustment_amount>=0" style="color:rgb(86 86 185)" class="omit-toggler--label">ROY+</label>
                  <label v-if="royaltyRate.ro.ppu_adjustment_amount<0" style="color:rgb(234, 35, 35)" class="omit-toggler--label">ROY-</label>
                </div>
              </div>
            </div>
          </div>
          <div class="ut-flex">
            <div class="search--input">
              <TextField
                :id="'deduction1'"
                class="m1"
                v-bind="textFieldConfig"
                :value="royaltyRate.ro.deduction1"
                :placeholder="$dft.capHead('deduction1')"
                @valuechanged="onTextFieldValueChange"
              />
            </div>
            <div class="search--checkbox omit">
              <div
                class="omit-toggler"
                :class="{
                  missed: isOmitted('deduction1')
                }"
                @click="e => onSearchOmittedToggle('deduction1')"
              >
                <!-- <div  class="dt-icon-container">
                  <img
                    :src="royaltyRate.ro.deduction1>0
                        ? 'static/icons/minus.svg'
                        : 'static/icons/plus.svg'
                    "
                    class="dt-icon s1 v7"
                    alt="Omit"
                    title="Omit"
                  />
                </div> -->
                <div  v-if="royaltyRate.ro.deduction1">
                  <label v-if="royaltyRate.ro.deduction1<0" style="color:rgb(86 86 185)" class="omit-toggler--label">ROY+</label>
                  <label v-if="royaltyRate.ro.deduction1>=0" style="color:rgb(234, 35, 35)" class="omit-toggler--label">ROY-</label>
                </div>
              
              </div>
            </div>
          </div>

          <div class="ut-flex">
            <div class="search--input">
              <TextField
                :id="'deduction2'"
                class="m1"
                v-bind="textFieldConfig"
                :value="royaltyRate.ro.deduction2"
                :placeholder="$dft.capHead('deduction2')"
                @valuechanged="onTextFieldValueChange"
              />
            </div>
            <div class="search--checkbox omit">
              <div
                class="omit-toggler"
                :class="{
                  missed: isOmitted('deduction2')
                }"
                @click="e => onSearchOmittedToggle('deduction2')"
              >
                <!-- <div v-if="royaltyRate.ro.deduction2" class="dt-icon-container">
                  <img
                    :src="royaltyRate.ro.deduction2>0
                      ? 'static/icons/minus.svg'
                        : 'static/icons/plus.svg'
                    "
                    class="dt-icon s1 v7"
                    alt="Omit"
                    title="Omit"
                  />
                </div> -->
                <div  v-if="royaltyRate.ro.deduction2">
                  <label v-if="royaltyRate.ro.deduction2<0" style="color:rgb(86 86 185)" class="omit-toggler--label">ROY+</label>
                  <label v-if="royaltyRate.ro.deduction2>=0" style="color:rgb(234, 35, 35)" class="omit-toggler--label">ROY-</label>
                </div>
              </div>
            </div>
          </div>

          <div class="ut-flex">
            <div class="search--input">
              <TextField
                :id="'deduction3'"
                class="m1"
                v-bind="textFieldConfig"
                :value="royaltyRate.ro.deduction3"
                :placeholder="$dft.capHead('deduction3')"
                @valuechanged="onTextFieldValueChange"
              />
            </div>
            <div class="search--checkbox omit">
              <div
                class="omit-toggler"
                :class="{
                  missed: isOmitted('deduction3')
                }"
                @click="e => onSearchOmittedToggle('deduction3')"
              >
                <!-- <div v-if="royaltyRate.ro.deduction3" class="dt-icon-container">
                  <img
                    :src="royaltyRate.ro.deduction3>0
                        ? 'static/icons/minus.svg'
                        : 'static/icons/plus.svg'
                    "
                    class="dt-icon s1 v7"
                    alt="Omit"
                    title="Omit"
                  />
                </div> -->
                <div  v-if="royaltyRate.ro.deduction3">
                  <label v-if="royaltyRate.ro.deduction3<0" style="color:rgb(86 86 185)" class="omit-toggler--label">ROY+</label>
                  <label v-if="royaltyRate.ro.deduction3>=0" style="color:rgb(234, 35, 35)" class="omit-toggler--label">ROY-</label>
                </div>
              </div>
            </div>
          </div>
          <TextField
            v-if="channel == 'physical'"
            :id="'sales_handling_fee'"
            class="m1"
            :inputType="'number'"
            v-bind="textFieldConfig"
            :value="royaltyRate.ro.sales_handling_fee"
            :placeholder="$t('sales_handling_fee')"
            @valuechanged="onTextFieldValueChange"
          />
          <TextField
            v-if="channel == 'physical'"
            :id="'return_handling_fee'"
            class="m1"
            :inputType="'number'"
            v-bind="textFieldConfig"
            :value="royaltyRate.ro.return_handling_fee "
            :placeholder="$t('royalty_return_handling_fee')"
            @valuechanged="onTextFieldValueChange"
          />
    
          
          <div class="dt-checkbox-control">
            <div class="dt-checkbox v2">
              <input
                type="checkbox"
                :name="'turnover_scale'"
                :id="'turnover_scale'"
                :checked="royaltyRate.ro.turnover_scale == 1"
                @change="e => onCheckboxChange('turnover_scale', e)"
              />
              <div class="checkmark"></div>
            </div>
            <div class="dt-checkbox-label">Turnover Scale</div>
          </div>
          <!-- </div> -->
        </div>

        <div class="dt-modal--column form-group">
          <div class="dt-modal--subtitle ut-mt-0">
            Apply on these conditions
          </div>
          <!-- <div class="dt-modal--column-body"> -->
          <Dropdown
            v-if="channel == 'physical'"
            :id="'transaction_type'"
            class="m2"
            :options="typeTV"
            :selected="
              typeTV.find(e => e.value == royaltyRate.ro.transaction_type)
            "
            :placeholder="$t('transaction_type')"
            deselect
            box
            @selectedChange="e => onDropdownChange('transaction_type', e)"
          ></Dropdown>

          <Dropdown
            :id="'territory'"
            class="m2"
            :options="territoryTV"
            deselect
            :selected="
              territoryTV.find(e => e.value == royaltyRate.ro.territory_id)
            "
            :placeholder="$t('territory')"
            box
            @selectedChange="e => onDropdownChange('territory_id', e)"
          ></Dropdown>

          <div v-if="channel == 'digital'">
            <b>Usage Type</b>
            <div class="dt-checkbox-control">
              <div class="dt-checkbox v2">
                <input
                  type="checkbox"
                  :name="'download_audio'"
                  :id="'download_audio'"
                  :checked="royaltyRate.ro.usage_type.includes('DL')"
                  @change="e => onUsageTypeCheckbox(e, 'DL')"
                />
                <div class="checkmark"></div>
              </div>
              <div class="dt-checkbox-label">
                {{ $t("download_audio") }}
              </div>
            </div>
            <div class="dt-checkbox-control">
              <div class="dt-checkbox v2">
                <input
                  type="checkbox"
                  :name="'download_video'"
                  :id="'download_video'"
                  :checked="royaltyRate.ro.usage_type.includes('DV')"
                  @change="e => onUsageTypeCheckbox(e, 'DV')"
                />
                <div class="checkmark"></div>
              </div>
              <div class="dt-checkbox-label">
                {{ $t("download_video") }}
              </div>
            </div>
            <div class="dt-checkbox-control">
              <div class="dt-checkbox v2">
                <input
                  type="checkbox"
                  :name="'streaming_audio'"
                  :id="'streaming_audio'"
                  :checked="royaltyRate.ro.usage_type.includes('STR')"
                  @change="e => onUsageTypeCheckbox(e, 'STR')"
                />
                <div class="checkmark"></div>
              </div>
              <div class="dt-checkbox-label">
                {{ $t("streaming_audio") }}
              </div>
            </div>
            <div class="dt-checkbox-control">
              <div class="dt-checkbox v2">
                <input
                  type="checkbox"
                  :name="'streaming_video'"
                  :id="'streaming_video'"
                  :checked="royaltyRate.ro.usage_type.includes('STV')"
                  @change="e => onUsageTypeCheckbox(e, 'STV')"
                />
                <div class="checkmark"></div>
              </div>
              <div class="dt-checkbox-label">
                {{ $t("streaming_video") }}
              </div>
            </div>
          </div>

          <Dropdown
            :id="'account'"
            class="m2"
            :options="accountTV"
            deselect
            :selected="
              accountTV.find(e => e.value == royaltyRate.ro.account_id)
            "
            :placeholder="$t('account')"
            box
            @selectedChange="e => onDropdownChange('account_id', e)"
          ></Dropdown>

          <Dropdown
            :id="'shop_group_title'"
            class="m2"
            :options="shopGroupTV"
            deselect
            :selected="
              shopGroupTV.find(e => e.value == royaltyRate.ro.shop_group_id)
            "
            :placeholder="$t('shop_group_title')"
            box
            @selectedChange="e => onDropdownChange('shop_group_id', e)"
          ></Dropdown>

          <Dropdown
            v-if="channel == 'digital'"
            :id="'bundle_track'"
            class="m2"
            deselect
            :options="digitalFormatTypesTV"
            :selected="
              digitalFormatTypesTV.find(
                e => e.value == royaltyRate.ro.format_type
              )
            "
            :placeholder="$t('bundle_track')"
            box
            @selectedChange="e => onDropdownChange('format_type', e)"
          ></Dropdown>

          <Dropdown
            v-if="channel == 'physical'"
            :id="'pricelist'"
            class="m2"
            deselect
            :options="pricelistTV"
            :selected="
              pricelistTV.find(e => e.value == royaltyRate.ro.pricelist_id)
            "
            :placeholder="$t('pricelist')"
            box
            @selectedChange="e => onDropdownChange('pricelist_id', e)"
          ></Dropdown>

          <Dropdown
            v-if="channel == 'physical'"
            :id="'album_single'"
            class="m2"
            deselect
            :options="physicalFormatTypesTV"
            :selected="
              physicalFormatTypesTV.find(
                e => e.value == royaltyRate.ro.format_type
              )
            "
            :placeholder="$t('album_single')"
            box
            @selectedChange="e => onDropdownChange('format_type', e)"
          ></Dropdown>

          <Dropdown
            v-if="channel == 'physical'"
            :id="'format_group'"
            class="m2"
            deselect
            :options="formatGroupsTV"
            :selected="
              formatGroupsTV.find(e => e.value == royaltyRate.ro.format_group)
            "
            :placeholder="$t('format_group')"
            box
            @selectedChange="e => onDropdownChange('format_group', e)"
          ></Dropdown>

          <Dropdown
            v-if="channel == 'physical'"
            :id="'product_type'"
            class="m2"
            deselect
            :options="productTypesTV"
            :selected="
              productTypesTV.find(
                e => e.value == royaltyRate.ro.product_type_id
              )
            "
            :placeholder="$t('product_type')"
            box
            @selectedChange="e => onDropdownChange('product_type_id', e)"
          ></Dropdown>

          <Dropdown
            :id="'barcode'"
            class="m2"
            :options="productsTV"
            deselect
            :selected="
              productsTV.find(e => e.value == royaltyRate.ro.product_id)
            "
            :placeholder="$t('catalog_no')"
            box
            @selectedChange="e => onDropdownChange('product_id', e)"
          ></Dropdown>

          <Dropdown
            :id="'release_project'"
            class="m2"
            :options="releasesTV"
            deselect
            :selected="
              releasesTV.find(e => e.value == royaltyRate.ro.release_id)
            "
            :placeholder="$t('release_project')"
            box
            @selectedChange="e => onDropdownChange('release_id', e)"
          ></Dropdown>

          <TextField
            v-if="channel == 'physical'"
            :id="'income_ppd_ratio'"
            class="m1"
            :inputType="'number'"
            v-bind="textFieldConfig"
            :value="royaltyRate.ro.ppd_ratio"
            :placeholder="$t('income_ppd_ratio')"
            @valuechanged="onTextFieldValueChange"
          />

          <Dropdown
            :id="'product_group'"
            class="m2"
            :options="productGroupsTV"
            deselect
            :selected="
              productGroupsTV.find(
                e => e.value == royaltyRate.ro.product_group_id
              )
            "
            :placeholder="$t('product_group')"
            box
            @selectedChange="e => onDropdownChange('product_group_id', e)"
          ></Dropdown>

          <TextField
            :id="'sales_age_in_month'"
            class="m1"
            :inputType="'number'"
            v-bind="textFieldConfig"
            :value="royaltyRate.ro.age_month"
            :placeholder="$t('sales_age_in_month')"
            @valuechanged="onTextFieldValueChange"
          />
        </div>
      
      </div>
      <!-- </div> -->
      <!-- </div> -->
    </template>

    <template slot="options">
      <button class="dt-button s6" @click.stop="onCancel">Cancel</button>
      <button class="dt-button v1 s6" @click.stop="onOkClick">Ok</button>
    </template>
  </Modal>
</template>

<script>
import Modal from "@dtplugins/modal/modal";
import InputField from "@plugins/text-field/input-field";
import { ContractsService } from "../../services/contracts.service";
import { async } from "rxjs/internal/scheduler/async";
import { createTV } from "../../../../models/text-value.model";
import { EventHooks } from "../../../../plugins/text-field";

export default {
  components: {
    Modal,
    InputField
  },
  props: ["selectedContractDetails"],
  data: function() {
    return {
      textFieldConfig: {
        height: 42,
        showEditIconOnHover: false,
        box: true,
        showValidationIcons: false,

        validationEvent: EventHooks.OnBlur,
        valueChangedEvent: EventHooks.OnBlur
      },

      royaltyRate: this.get_royaltyRate()
    };
  },
  mounted: async function() {


    console.log(":::::::",this.seqLength,":::::::::::");



    if (this.isEditMode) {
      if (this.channel == "physical") {
        const res = await ContractsService.physicalRoyaltyForm({
          contract_id: this.contract_id,
          royalty_option_id: this.royalty_option_id
        });
        this.royaltyRate = res.data;
      } else if (this.channel == "digital") {
        const res = await ContractsService.digitalRoyaltyForm({
          contract_id: this.contract_id,
          royalty_option_id: this.royalty_option_id
        });
        console.log('res.data::::::::',res.data)
        this.royaltyRate = {...res.data, ro:{...res.data.ro,usage_type:res.data.ro.usage_type?res.data.ro.usage_type:""} , usage_types:res.data.usage_types };
      }
    } else if (this.isAddMode) {
      if (this.channel == "physical") {
        const addRes = await ContractsService.physicalRoyaltyForm({
          contract_id: this.contract_id,
          royalty_option_id: "undefined" //  if add undefind
        });

    


        this.royaltyRate = {
          ...addRes.data,
          ...this.royaltyRate
        };
      } 
      else if (this.channel == "digital") {
        const addRes = await ContractsService.digitalRoyaltyForm({
          contract_id: this.contract_id,
          royalty_option_id: "undefined" //  if add undefind
        });

        console.log('addRes.data::::::::',addRes.data)
        this.royaltyRate = {
          ...addRes.data,
          ...this.royaltyRate,
          
        };
      }
    }
  },
  computed: {
    contract_id: function() {
      return this.$route.params.contract_id;
    },
    royalty_option_id: function() {
      return this.$route.query.royalty_option_id;
    },
    channel: function() {
      return this.$route.query.channel;
    },
    mode: function() {
      return this.$route.query.mode;
    },
    seqLength:function(){
      return this.$route.query.seqLength;
    },
    isEditMode: function() {
      return this.mode == "edit";
    },
    isAddMode: function() {
      return this.mode == "add";
    },
    title: function() {
      if (this.isEditMode) {
        return "Edit";
      } else if (this.isAddMode) {
        return "Add";
      } else {
        return "";
      }
    },

    physicalBaseTV: function() {
      return this.royaltyRate.physical_ro_bases.map(x=>{
            if(x.textkey=='rob_ppd'){
              return{
                text:this.$t('rob_product_ppd'),
                value:this.$t(x.value)
              }
            }
            else{
              return{
                text:this.$t(x.textkey),
                value:this.$t(x.value)
              }
            }

              
            })
      
      //createTV(this.royaltyRate.physical_ro_bases, "textkey", "value");
    },
    digitalBaseTV: function() {
      return  this.royaltyRate.digital_ro_bases.map(x=>{
        return{
          text:this.$t(x.textkey),
          value:this.$t(x.value)
        }
      })
      
      //createTV(this.royaltyRate.digital_ro_bases, "textkey", "value");
    },
    typeTV: function() {
      return createTV(this.royaltyRate.transaction_types, "label", "value");
    },
    territoryTV: function() {
      return createTV(this.royaltyRate.territories, "label", "value");
    },
    accountTV: function() {
      return createTV(this.royaltyRate.accounts, "label", "value");
    },
    shopGroupTV: function() {
      return [
        {
          text: "Special Shop Groups",
          value: "-"
        },
        ...(this.royaltyRate?.general_shop_groups?.map(e => ({
          text: e.shop_group_name,
          value: e.shop_group_id
        })) || []),
        {
          text: "General Shop Groups",
          value: "-"
        },
        ...(this.royaltyRate?.special_shop_groups?.map(e => ({
          text: e.shop_group_name,
          value: e.shop_group_id
        })) || [])
      ];
    },
    pricelistTV: function() {
      return createTV(this.royaltyRate.price_lists, "label", "value");
    },
    physicalFormatTypesTV: function() {
      return createTV(this.royaltyRate.physical_format_types, "label", "value");
    },
    formatGroupsTV: function() {
      return createTV(this.royaltyRate.format_groups);
    },
    productTypesTV: function() {
      return createTV(this.royaltyRate.product_types, "label", "value");
    },
    productsTV: function() {
      return createTV(
        this.royaltyRate.products,
        "product_catalog_no",
        "product_id"
      );
    },
    releasesTV: function() {
      return createTV(this.royaltyRate.releases, "release_name", "release_id");
    },
    productGroupsTV: function() {
      return createTV(
        this.royaltyRate.product_groups,
        "product_group_name1",
        "product_group_id"
      );
    },
    digitalFormatTypesTV: function() {
      return createTV(this.royaltyRate.digital_format_types, "label", "value");
    },
    saveRoyaltyOption: function() {
      return {
        option_name: this.royaltyRate?.ro?.option_name,
        royalty_rate: this.royaltyRate?.ro?.royalty_rate,
        base: this.royaltyRate?.ro?.base,
        ppu_adjustment: this.royaltyRate?.ro?.ppu_adjustment,
        ppu_adjustment_amount:this.royaltyRate?.ro?.ppu_adjustment_amount,
        deduction1: this.royaltyRate?.ro?.deduction1,
        deduction2: this.royaltyRate?.ro?.deduction2,
        deduction3: this.royaltyRate?.ro?.deduction3,
        return_handling_fee: this.royaltyRate?.ro?.return_handling_fee,
        sales_handling_fee: this.royaltyRate?.ro?.sales_handling_fee,
        turnover_scale: this.royaltyRate?.ro?.turnover_scale,
        transaction_type: this.royaltyRate?.ro?.transaction_type,
        territory_id: this.royaltyRate?.ro?.territory_id,
        account_id: this.royaltyRate?.ro?.account_id,
        shop_group_id: this.royaltyRate?.ro?.shop_group_id,
        pricelist_id: this.royaltyRate?.ro?.pricelist_id,
        format_type: this.royaltyRate?.ro?.format_type,
        format_group: this.royaltyRate?.ro?.format_group,
        product_type_id: this.royaltyRate?.ro?.product_type_id,
        product_id: this.royaltyRate?.ro?.product_id,
        release_id: this.royaltyRate?.ro?.release_id,
        ppd_ratio: this.royaltyRate?.ro?.ppd_ratio,
        product_group_id: this.royaltyRate?.ro?.product_group_id,
        age_month: this.royaltyRate?.ro?.age_month,
        usage_type: this.royaltyRate?.ro?.usage_type,
        contract_id: this.contract_id,
        sequence_no: this.royaltyRate?.ro?.sequence_no,
        royalty_option_id: this.royalty_option_id
      };
    }
  },
  methods: {
    onCancel: function() {
      this.$emit("cancelled", true);
    },

    onTextFieldValueChange: function(name, value) {
      if(name=='income_ppd_ratio'){
        this.royaltyRate.ro['ppd_ratio']=value
      }else if(name=='sales_age_in_month'){
        this.royaltyRate.ro['age_month']=value
      }
      else{
        this.royaltyRate.ro[name] = value;
      }
      
    },

    onDropdownChange(name, value) {
      this.royaltyRate.ro[name] = value.value;
    },
    onCheckboxChange: function(name, event) {
      const value = event.target.checked ? "1" : "0";
      this.royaltyRate.ro[name] = value;
    },
    onUsageTypeCheckbox: function(event, value) {
      const checked = event.target.checked;
      const selectedUsageTypes =
        this.royaltyRate.ro.usage_type == "" ||  this.royaltyRate.ro.usage_type == null
          ? []
          : this.royaltyRate.ro.usage_type.split(",");
      if (checked && !selectedUsageTypes.includes(value)) {
        this.royaltyRate.ro.usage_type = [...selectedUsageTypes, value].join(
          ","
        );
      } else if (!checked && selectedUsageTypes.includes(value)) {
        this.royaltyRate.ro.usage_type = selectedUsageTypes
          .filter(e => e != value)
          .join(",");
      }
    },

    onOkClick: async function() {
      if (this.mode == "add") {
       
        if (this.channel == "physical") {
          const res = await ContractsService.savePhysicalRoyalty(
            {
              ...this.saveRoyaltyOption,
              sequence_no:this.seqLength+1

            }
            
          );

           console.log("::::::::::","OOOOOOOOOOOOOOOOOOOOOOOO",res.data)


          this.$emit("added", {
            ...res.data,
            channel: this.channel
          });
        } else if (this.channel == "digital") {
          const res = await ContractsService.saveDigitalRoyalty(
            {  
              ...this.saveRoyaltyOption,
              sequence_no:this.seqLength+1
            }
          );
            console.log("::::::::::","OOOOOOOOOOOOOOOOOOOOOOOO",res.data)
          this.$emit("added", {
            ...res.data,
            channel: this.channel
          });
        }
      } else if (this.mode == "edit") {
        this.$emit("edited", {
          channel: this.channel,
          modalEdit: true,
          item: this.royaltyRate?.ro,
          saveRoyaltyOption: this.saveRoyaltyOption
        });
      }
    },

    onSearchOmittedToggle: function(name) {
      if (this[`${name}_missing`] == 1) {
        this[`${name}_missing`] = "0";
      } else {
        this[`${name}_missing`] = `1`;
      }
    },
    isOmitted(name) {
      return this[`${name}_missing`] == `1`;
    },

    get_royaltyRate: function() {
      return {
        ro: {
          option_name: null,
          royalty_rate: null,
          base: null,
          ppu_adjustment: null,
          deduction1: null,
          deduction2: null,
          deduction3: null,
          ppu_adjustment_amount:null,
          return_handling_fee: null,
          sales_handling_fee: null,
          turnover_scale: null,
          transaction_type: null,
          territory_id: null,
          account_id: null,
          shop_group_id: null,
          pricelist_id: null,
          format_type: null,
          format_group: null,
          product_type_id: null,
          product_id: null,
          release_id: null,
          ppd_ratio: null,
          product_group_id: null,
          age_month: null,
          usage_type: ""
        },
        usage_types:[]
      };
    }
  }
};
</script>

<style lang="scss">
.cmp-royalty-contracts-sidewindow-royalty_rate_form {
  overflow: hidden;
  overflow-y: auto;
  // .body-container {
  //   max-height: 460px;
  //   padding-right: 15px;
  //   overflow: hidden;
  //   overflow-y: auto;
  //   .dt-modal--subtitle {
  //     &:first-child {
  //       margin-top: 0;
  //     }
  //   }
  // }
  .dt-modal--body{
    height: 500px;
    overflow: auto;
  }
  .dt-modal--row{
    margin: 0px;
  }
  .dt-checkbox-control {
    align-items: center;
    .dt-checkbox-label {
      flex: 1;
      padding-left: 10px;
    }
  }

  .omit-toggler {
    display: flex;
    cursor: pointer;

    &.missed {
      color: var(--c-error);
    }

    .omit-toggler--label {
      margin: auto 0px auto 4px;
      cursor: pointer;
    }
  }

  .search--input {
    flex: 1;
  }

  .search--checkbox {
    min-width: 20px;
    margin-left: 4px;

    display: flex;
    flex-direction: column;
    justify-content: center;

    @media screen and (min-width: 320px) and (max-width: 480px) {
      padding-left: 0px;
      margin-left: 0px;

      .checkmark {
        margin-left: 10px;
      }
    }
  }
}
</style>
